import { OIDCReactLib } from "@bnsf/oidc-token-lib-react/lib";
import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import { BrowserRouter } from "react-router-dom";
import AppRouter from "./router";

const App = () => {
  return (
    <>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <OIDCReactLib />
    </>
  );
};

export default App;
